module.exports = __webpack_public_path__ + "static/discount2-f404cf1612cb69cdedc7a8c1250c1f73.jpg";